import React, { useState, useRef, useEffect } from "react";
import {
  useSetCurrentTrack,
  useStoreContext,
  useToggleMediaPlayer,
  useSetCourseMedia,
} from "src/context/siteContext";
import ReactHowler from "react-howler";
import MediaControls from "./MediaControls";

import useInterval from "../../hooks/useInterval";
import cookie from "js-cookie";

const AudioPlayer = () => {
  const {
    courseMediaType,
    currentTrack,
    courseMediaFiles = [],
  } = useStoreContext();
  const [isTrackLoaded, setIsTrackLoaded] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const [progress, setProgress] = useState(0);
  const [position, setPosition] = useState(0);
  const [duration, setDuration] = useState(0);

  const setMediaPlayerOpen = useToggleMediaPlayer();
  const setCourseMedia = useSetCourseMedia();
  const setCurrentTrack = useSetCurrentTrack();
  const audioRef = useRef();

  const { title, audioUrl } = currentTrack ? currentTrack : {};

  const canClickPrev = courseMediaFiles.indexOf(currentTrack) !== 0;
  const canClickNext =
    courseMediaFiles.indexOf(currentTrack) !== courseMediaFiles.length - 1;

  useInterval(
    () => {
      const currentProgress = (
        (audioRef.current.seek() / audioRef.current.duration()) *
        100
      ).toFixed(2);
      setPosition(audioRef.current.seek());
      setProgress(Number(currentProgress));
    },
    isPlaying ? 100 : null
  );

  useInterval(
    () => {
      const currentProgress = Number(
        ((audioRef.current.seek() / audioRef.current.duration()) * 100).toFixed(
          0
        )
      );
      const currentSeek = audioRef.current.seek();

      cookie.set(
        `district-vision__course-track-${currentTrack._key}`,
        { currentProgress, currentSeek },
        { expires: 31 }
      );
    },
    isPlaying ? 100 : null
  );

  const onSeek = (value) => {
    setIsPlaying(false);

    const percentage = value / 100;
    const audioDuration = audioRef.current.duration();
    const newAudioValue = Number(audioDuration * percentage);

    audioRef.current.seek(newAudioValue);
    setIsPlaying(true);
  };

  const goNext = () => {
    if (!canClickNext) return;
    const nextTrack = courseMediaFiles.indexOf(currentTrack) + 1;
    setCurrentTrack(courseMediaFiles[nextTrack]);
  };

  const goPrev = () => {
    if (!canClickPrev) return;
    const prevTrack = courseMediaFiles.indexOf(currentTrack) - 1;
    setCurrentTrack(courseMediaFiles[prevTrack]);
  };

  // useEffect(() => {
  //   if (courseMediaType === "audio" && audioRef.current) {
  //     setTimeout(() => {
  //       const trackDuration = audioRef.current.duration();
  //       setDuration(trackDuration);
  //       if (progressElement) {
  //         progressElement.innerText = "";
  //       }
  //       setIsPlaying(true);
  //     }, 250);
  //   }
  // }, [courseMediaType, currentTrack, audioRef.current]);

  useEffect(() => {
    const savedProgressCookie = cookie.get(
      `district-vision__course-track-${currentTrack._key}`
    );
    const parsedProgress =
      savedProgressCookie && JSON.parse(savedProgressCookie);

    if (parsedProgress) {
      console.log(`loading track ${parseInt(parsedProgress.currentProgress)}%`);
      if (parseInt(parsedProgress.currentProgress) < 99) {
        audioRef.current.seek(parsedProgress.currentSeek);
      } else {
        audioRef.current.seek(0);
      }
    }
  }, [currentTrack]);

  return (
    <div className="media-player--audio">
      <div className="media-player__close media-player__close--audio">
        <button
          onClick={() => {
            setMediaPlayerOpen(false);
            setIsPlaying(false);
            setProgress(0);
            setCourseMedia(undefined, []);
          }}
        >
          X <span className="underline-on-hover">Close</span>
        </button>
      </div>
      {currentTrack && (
        <ReactHowler
          src={[audioUrl]}
          playing={isPlaying}
          onEnd={() => {
            if (!canClickNext) {
              setMediaPlayerOpen(false);
              setIsPlaying(false);
              setProgress(0);
              setCourseMedia(undefined, []);
              return;
            }
            goNext();
          }}
          onLoad={() => {
            setDuration(audioRef.current.duration());
            setIsPlaying(true);
          }}
          loop={false}
          mute={false}
          ref={audioRef}
          html5={true}
          format={["mp3", "wav"]}
        />
      )}
      <MediaControls
        title={`${courseMediaFiles.indexOf(currentTrack) + 1}. ${title}`}
        progress={progress}
        position={position}
        duration={duration}
        isPlaying={isPlaying}
        onSeek={onSeek}
        canClickPrev={canClickPrev}
        canClickNext={canClickNext}
        onClickNext={goNext}
        onClickPrev={goPrev}
        onTogglePlayback={() => {
          setIsPlaying(!isPlaying);
        }}
      />
    </div>
  );
};

export default AudioPlayer;
